export const Divider = {
  baseStyle: {
    opacity: 1,
    borderColor: 'neutral.300',
  },
}
